import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter} from "@insite/client-framework/Services/ApiService";

export interface InvoiceParameter extends ApiParameter {
    invoiceNumber: any;
    onError?: (error: string) => void;
}

export interface InvoiceApiModel { }

export async function getUnifiedARInvoice(
    parameter: InvoiceParameter & HasOnSuccess<InvoiceParameter> & HasOnComplete<InvoiceParameter>,
) {
    fetch(`/api/v1/UnifiedARInvoice/Invoice?invoiceNumber=${parameter.invoiceNumber}`, {
        headers: {
            'Content-Type': 'application/json', // Set the appropriate content type for your request
        },
    })
        .then( async response => {
            // Access response headers
            const headers = response.headers;
            // Get a specific header value
            const redirectURL = headers.get('Location') ?? "/";
            //Redirect user to PDF URL recieved in headers.
            window.open(redirectURL, '_blank');
            return await response.text();
        })
}